import { React, useState, useContext, useEffect } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import sideImg from '../../../images/auth_form_eng.jpg'
import { AuthContext } from '../../../context/authContext'
import axios from "../../../api/axios"
import { StaffRegisterRoute, StaffVerifyRegisterTokenRoute } from "../../../routes"


const StaffDetails = () => {
    const [input, setInput] = useState({
        email: "",
        username: "",
        role: "",
        password: "",
        confirm: "",
    })

    const [error, setError] = useState("")


    const navigate = useNavigate()

    const location = useLocation()
    useEffect(() => {
        const verifyTokenRoute = async () => {

            await axios.get(StaffVerifyRegisterTokenRoute + location.pathname.split('/')[3])
                .then((response) => {
                    setInput(prevData => ({
                        ...prevData,
                        email: response.data.email,
                        username: response.data.username,
                        role: response.data.role,
                    }))
                })
                .catch((error) => {
                    // console.log(error)
                    setError("Your Token has expired. Please retry registering")
                })

        }
        verifyTokenRoute()
    }, [])
    // const {login} = useContext(AuthContext)
    //Handle Changes in form
    function changeHandler(event) {
        const { name, value } = event.target
        setInput(prevData => ({
            ...prevData,
            [name]: value
        }))
    }

    {/**Might not be required with form 'required'? */ }
    const submitHandler = async (event) => {
        event.preventDefault()
        // //console.log(event)

        if (!input.password) {
            setError("Password required!")
        }
        else if (input.password.length < 8) {
            setError("Password should be atleast 8 characters long!")
        }
        else if (input.confirm !== input.password)
            setError("Passwords do not match!")
        else {
            console.log("Posting password")
            await axios.post(StaffRegisterRoute, input)
                .then((response) => {
                    navigate("/dev/login")
                })
                .catch((err) => {
                    setError(err.response.data)
                })
            // //console.log(err)
        }
    }


    //console.log(input)

    return (
        <div className="auth-container">
            <img src={sideImg}></img>
            <div className="auth">
                <h1>Register</h1>
                <form>
                    <p style={{ color: "black" }}>Set up your account password</p>
                    <p className="error">{error}</p>
                    <input required type="password"
                        placeholder="Password"
                        name="password"
                        value={input.password}
                        onChange={changeHandler}
                    />
                    <input required type="password"
                        placeholder="Confirm Password"
                        name="confirm"
                        value={input.confirm}
                        onChange={changeHandler}
                    />
                    <button onClick={submitHandler}>Submit</button>

                </form>
            </div>
        </div>
    )
}

export default StaffDetails